import styled, { css } from 'styled-components';
import { borderRadius, colorUsage, getSpacing } from 'stylesheet';
import { Pen, Trash } from 'theme/icons';
var ProductItem = styled.div.withConfig({
  displayName: "ProductListstyle__ProductItem",
  componentId: "sc-67yiph-0"
})(["position:relative;display:flex;width:520px;"]);
var ProductPreview = styled.div.withConfig({
  displayName: "ProductListstyle__ProductPreview",
  componentId: "sc-67yiph-1"
})(["display:flex;flex-direction:row;width:500px;margin-top:", ";padding:", ";column-gap:", ";border:1px solid ", ";border-radius:", ";"], getSpacing(1), getSpacing(1), getSpacing(2), colorUsage.searchItemList.borderColor, borderRadius.medium);
var ProductImageContainer = styled.div.withConfig({
  displayName: "ProductListstyle__ProductImageContainer",
  componentId: "sc-67yiph-2"
})(["width:80px;height:56px;"]);
var ProductImage = styled.img.withConfig({
  displayName: "ProductListstyle__ProductImage",
  componentId: "sc-67yiph-3"
})(["display:block;width:auto;max-width:80px;height:auto;max-height:56px;margin:auto;border:1px solid ", ";border-radius:", ";"], colorUsage.imageBorder, borderRadius.small);
var ProductInfo = styled.div.withConfig({
  displayName: "ProductListstyle__ProductInfo",
  componentId: "sc-67yiph-4"
})(["display:flex;flex-direction:column;"]);
var ProductName = styled.div.withConfig({
  displayName: "ProductListstyle__ProductName",
  componentId: "sc-67yiph-5"
})([""]);
var ProductOffer = styled.div.withConfig({
  displayName: "ProductListstyle__ProductOffer",
  componentId: "sc-67yiph-6"
})(["color:", ";"], colorUsage.textColorLight);
var iconProperties = css(["position:absolute;right:0;width:14px;height:14px;cursor:pointer;& path{fill:", ";}&:hover path{fill:", ";}"], colorUsage.defaultIconColor, colorUsage.iconHover);
var EditIcon = styled(Pen).withConfig({
  displayName: "ProductListstyle__EditIcon",
  componentId: "sc-67yiph-7"
})(["", " top:", ";"], iconProperties, getSpacing(3));
var RemoveIcon = styled(Trash).withConfig({
  displayName: "ProductListstyle__RemoveIcon",
  componentId: "sc-67yiph-8"
})(["", " top:", ";&:hover path{fill:", ";}"], iconProperties, getSpacing(5.5), colorUsage.iconRemove);
export { EditIcon, ProductImage, ProductImageContainer, ProductInfo, ProductItem, ProductName, ProductOffer, ProductPreview, RemoveIcon };